<div class="layout-topbar">
  <a class="" routerLink="/">
    <h2 class="text-white fw-bold">
      Staff Pestforce
    </h2>
  </a>

  <button #menubutton class="topbar-menubutton p-link" type="button" (click)="onMenuButtonClick()">
    <span></span>
  </button>

  <ul class="topbar-menu">
    <li *ngFor="let item of tabs; let i = index">
      <a
        [routerLink]="item.routerLink"
        routerLinkActive="active-route"
        [routerLinkActiveOptions]="item.routerLinkActiveOptions || { paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }"
        [fragment]="item.fragment"
        [queryParamsHandling]="item.queryParamsHandling"
        [preserveFragment]="item.preserveFragment!"
        [skipLocationChange]="item.skipLocationChange!"
        [replaceUrl]="item.replaceUrl!"
        [state]="item.state"
        [queryParams]="item.queryParams"
      >
        <span>{{ item.label }}</span>
      </a>

      <i class="pi pi-times" (click)="removeTab($event, item, i)"></i>
    </li>
  </ul>

  <div class="notification-container">
    <button #notificationButton class="notification-button p-link" (click)="toggleNotificationsDropdown()">
      <i class="pi pi-bell"></i>
      <span *ngIf="hasUnreadNotifications" class="notification-badge"></span>
    </button>

    <div #notificationDropdown *ngIf="showNotificationsDropdown" class="notification-dropdown">
      <div class="notification-header">
        <h4>Notificaciones</h4>
        <button class="mark-all-read" (click)="markAsRead()" pButton pRipple label="Marcar todas como leídas"></button>
      </div>

      <div *ngIf="notifications.length === 0" class="empty-notifications">
        No hay notificaciones nuevas
      </div>

      <div class="notification-list">
        <div *ngFor="let notification of notifications" class="notification-item" [class.unread]="!notification.read"
          (click)="openNotification(notification)">
          <div class="notification-title">{{ notification.module }}</div>
          <div class="notification-description">{{ notification.description }}</div>

          <div class="notification-meta">
            <span class="module">{{ notification.body?.body || '' }}</span>
            <span class="sender">
              <app-avatar-notification [name]="notification.made_at.name" [color]="notification.made_at.color" />
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="notifications.length >= 10" class="view-all">
        <a (click)="router.navigate(['/notifications'])" pRipple class="text-primary hov-pointer">Ver todas las
          notificaciones</a>
      </div>
    </div>
  </div>

  <div class="topbar-profile">
    <button class="topbar-profile-button p-link" type="button" pStyleClass="@next" enterClass="hidden"
      enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
      <img alt="avatar" [src]="getPicture()">

      <span class="profile-details">
        <span class="profile-name">
          {{ user.name }}
        </span>
      </span>

      <i class="pi pi-angle-down"></i>
    </button>

    <ul
      class="list-none p-3 m-0 border-round shadow-2 hidden absolute surface-overlay origin-top w-full sm:w-12rem mt-2 right-0 top-auto"
      style="z-index: 1001;">
      <li>
        <a (click)="logout()" pRipple
          class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
          <i class="pi pi-power-off mr-3"></i>
          <span>Cerrar sesión</span>
        </a>
      </li>
    </ul>
  </div>
</div>
